/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

export enum ExportFormatType {
	Touchplan = 'touchplan',
	P6Excel = 'p6Excel',
	CSV = 'csv',
	OPCExcel = 'opcExcel',
	MSPExcel = 'mspExcel',
}
